interface MarkdownSection {
  title: string
  content: string
  level: number
  titleTooltip?: string
}

const tooltipByTitle: Record<string, string> = {
  ['Recurring Issues from Past Year']:
    'Recurring issues from the last 12 months prior to this booking’s check-out date',
}

export const parseSummaryMarkdownSections = (markdown?: string): MarkdownSection[] => {
  if (!markdown) return []

  const summaryMarker = '## **Summary**'
  const backupSummaryMarker = '## Summary'
  const summaryStartIndex = markdown.indexOf(summaryMarker)
  const backupSummaryStartIndex = markdown.indexOf(backupSummaryMarker)

  const currentSummaryStartIndex =
    summaryStartIndex !== -1 ? summaryStartIndex : backupSummaryStartIndex

  if (currentSummaryStartIndex === -1) {
    return []
  }

  const contentToParse = markdown.substring(currentSummaryStartIndex)

  const normalizedMarkdown = contentToParse
    .replace(/\\n/g, '\n')
    .replace(/\n\s*\n/g, '\n')
    .trim()

  const sections = normalizedMarkdown.split(/(?=^##(?!#)\s)/m)

  return sections
    .filter(section => section.trim()) // Remove empty sections
    .map(section => {
      const [titleLine, ...contentLines] = section.split('\n')

      const level = 2

      const title = titleLine
        .replace(/\*\*/g, '')
        .replace(/^##\s*/, '')
        .trim()

      const content = contentLines.join('\n').trim()

      const titleTooltip = tooltipByTitle[title]

      return { title, content, level, titleTooltip }
    })
}

export const parseGenericMarkdownSections = (
  markdown?: string | null,
): Array<{ title: string; content: string; level: number }> => {
  if (!markdown) return []

  const normalized = markdown
    .replace(/\\n/g, '\n')
    .replace(/\r\n?/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

  const headingRegex = /^(#{1,6})\s+(.+?)\s*$/gm

  const headingMatches = Array.from(normalized.matchAll(headingRegex))

  if (!headingMatches.length) {
    return [{ title: 'Content', content: normalized, level: 0 }]
  }

  return headingMatches.reduce<Array<{ title: string; content: string; level: number }>>(
    (acc, match, idx, arr) => {
      const title = (match[2] ?? '').trim()
      const level = (match[1] ?? '').length
      const start = (match.index ?? 0) + match[0].length
      const end =
        idx < arr.length - 1 ? (arr[idx + 1].index ?? normalized.length) : normalized.length
      const content = normalized.slice(start, end).trim()
      return [...acc, { title, content, level }]
    },
    [],
  )
}
